import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';


import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';
import { URL_EMPLOYEE } from '../../constans/servidor';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import TableComponent from '../../components/Desenganche/Filtrado';
import { set } from 'immutable';
let dato = []
let cambiar = false

function Formulario(props) {
	const { Terminales } = props;
	const [myVariable, setMyVariable] = useState('Valor inicial');

	const [errorMessageA, setErrorMessageA] = useState('');
	const [errorMessageB, setErrorMessageB] = useState('');
	const [placa, setPlaca] = useState();
	const [objeto, setObjeto] = useState()
	const [loading, setLoading] = useState(true);
	const [estado, setEstado] = useState()
	// const [TerminalesB, setTerminalesB] = useState();

	const [datosCorrectosA, setdatosCorrectosA] = useState(false);
	const [datosCorrectosB, setdatosCorrectosB] = useState(false);
	const {
		control,
		watch,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();
	const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
	const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
	const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
	const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
	const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
	const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
	const regExpBicis = /^[Bb]ici[0-9]{3}$/;
	const regExpBici = /^[Bb]ici[0-9]{2}$/;


	const verificarPlaca = (placa) => {
		console.log(placa);
		if (
			regExpCarro.test(placa) ||
			regExpCarroR.test(placa) ||
			regExpCarroA.test(placa) ||
			regExpCarroV.test(placa) ||
			regExpMoto.test(placa) ||
			regExpMotoAntigua.test(placa) ||
			regExpBicis.test(placa) ||
			regExpBici.test(placa)
		) {
			console.log('entre');
			setPlaca(true);
		} else {
			setPlaca(false);
		}
	};
	const onSubmit = async (data) => {
		// creas un array vacío
		cambiar = true
		try {

			const resultado = await axios.get(`${URL_EMPLOYEE}/desenganchadas/consultarPlacasEnganchadas/""/${data.placa}`)
			if (resultado.data["status"]) {
				setEstado(true)
			} else {
				setEstado(false)
			}
		} catch (error) {
			toast.error('Algo salio mal..');
		}
		const placas = data.placa
		var fechaSeleccionada = new Date(data.fecha);
		var anio = fechaSeleccionada.getFullYear();
		var mes = fechaSeleccionada.getMonth() + 1;
		var dia = fechaSeleccionada.getDate();
		var fechaFormateada = anio + "-" + (mes < 10 ? "0" + mes : mes) + "-" + (dia < 10 ? "0" + dia : dia);
		let miObjeto = { // creas un objeto
			cod_park: data.terminalesF.value,
			placa: placas.toUpperCase(),
			solicitadoPor: data.nombre,
			concepto: data.descripcion.value,
			observaciones: data.observacion,
			fechaEnganchada: fechaFormateada
		};

		dato.push(miObjeto);

		console.log(dato);
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Row className={estado ? "azul mbottom-20" : (estado === false ? "rojo mbottom-20" : "contenedorF-Filtrado mbottom-20")}>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputplaca">
						<Form.Label className='texto-label'>
							Placa<span>Ingrese solo numeros y letras</span>
						</Form.Label>
						<Controller
							name="placa"
							control={control}
							rules={{
								required: {
									value: true,
									message: 'El campo es obligatorio',
								}
							}}
							defaultValue=""
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="text"
									onBlur={onBlur}
									onChange={(value) => {
										onChange(value);
										verificarPlaca(value.target.value);
									}
									}
									value={value}
									maxLength={7}
									onKeyUp={(event) => {
										if (event.target.value.length >= 7 || event.target.value.length >= 5) {
											setdatosCorrectosA(true);
										} else {
											setdatosCorrectosA(false);
										}
										if (event.target.value.length >= 7) {
											setErrorMessageA('Ya ingreso el numero total de caracteres');
										} else {
											setErrorMessageA('');
										}
									}}
								/>
							)}
						/>
						{errors.placa && (
							<Form.Text id="passwordHelpBlock" className="error">
								{errors.placa.message}
							</Form.Text>
						)}
						{errorMessageA && (
							<Form.Text id="passwordHelpBlock" className="correcto">
								{errorMessageA}
							</Form.Text>
						)}
						{!placa && (
							<Form.Text id="passwordHelpBlock" className="error">
								Ingrese una placa valida
							</Form.Text>
						)}
					</Form.Group>
				</Col>
				{Terminales ? (
					<Col xs={12} sm={6} md={4} lg={4} xl={4}>
						<Form.Group controlId="formBasicEmail">
							<Form.Label className='texto-label'>Parqueaderos</Form.Label>
							<Controller
								name="terminalesF"
								control={control}
								rules={{
									required: {
										value: true,
										message: 'El campo es obligatorio',
									}
								}}
								// rules={{ required: true }}
								defaultValue=""
								render={({ field: { onChange, onBlur, value } }) => (
									<Select
										onChange={(data) => { onChange(data) }}
										value={value}
										// placeholder="Elige una opción"
										options={Terminales}
									/>

								)}
							/>
							{errors.terminalesF && (
								<Form.Text id="passwordHelpBlock" className="error">
									{errors.terminalesF.message}
								</Form.Text>
							)}
						</Form.Group>
					</Col>
				) : null}
				<Col xs={12} sm={4} md={4} lg={4} xl={4}>
					<Form.Group controlId="formBasicEmail">
						<Form.Label className='texto-label'>Fecha de Enganche</Form.Label>
						<Controller
							name="fecha"
							control={control}
							rules={{ required: true }}
							defaultValue={new Date()}
							render={({ field: { onChange, onBlur, value } }) => (
								<DatePicker
									className="form-control"
									selected={value}
									dateFormat="yyyy-MM-dd"
									onChange={(date) => onChange(date)}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group controlId="formBasicEmail">
						<Form.Label className='texto-label'>Concepto</Form.Label>
						<Controller
							name="descripcion"
							control={control}
							rules={{
								required: {
									value: true,
									message: 'El campo es obligatorio',
								}
							}}
							defaultValue=''
							render={({ field: { onChange, onBlur, value } }) => (
								<Select
									onChange={(data) => {
										onChange(data);
									}}
									value={value}
									// placeholder="Elige una opción"
									options={[
										{ value: 'Autorizado', label: "Autorizado" },
										{ value: 'Beparking', label: "Beparking" },
										{ value: 'Cobro Manual', label: "Cobro Manual" },
										{ value: 'Descuento Nomina', label: "Descuento Nomina" },
										{ value: 'Falla del Sistema', label: "Falla del Sistema" },
										{ value: 'Falla de Energia', label: "Falla de Energi" },
										{ value: 'Funcionario', label: "Funcionario" },
										{ value: 'Operario', label: "Operario" },
										{ value: 'Gopass', label: "Gopass" },
										{ value: 'Mensuaidad', label: "Mensuaidad" },
										{ value: 'Ruedaz', label: "Ruedaz" },
										{ value: 'Sobrante', label: "Sobrante" },
										{ value: 'Tarea', label: "Tarea" },
										{ value: 'Placa mal Digitada', label: "Placa mal Digitada" }

									]}
								/>

							)}
						/>
						{errors.descripcion && (
							<Form.Text id="passwordHelpBlock" className="error">
								{errors.descripcion.message}
							</Form.Text>
						)}
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group className="inputmayuscula">
						<Form.Label className='texto-label'>Nombre Solicitante</Form.Label>
						<Controller
							name="nombre"
							control={control}

							defaultValue="Sandra Rodriguez"
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									type="text"
									onBlur={onBlur}
									onChange={(value) => onChange(value)}
									value={value}
									disabled={true}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6} md={4} lg={4} xl={4}>
					<Form.Group controlId="formBasicPassword">
						<Form.Label className='texto-label'>Observación </Form.Label>
						<Controller
							name="observacion"
							control={control}
							render={({ field: { onChange, onBlur, value } }) => (
								<Form.Control
									as="textarea"
									rows={3}
									placeholder="Escribe tu mensaje"
									onChange={(value) => onChange(value)}
								/>
							)}
						/>
					</Form.Group>
				</Col>
				<Col className="  mbottom-20" xs={12} sm={4} md={4} lg={4} xl={4}>

					<Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
					>
						<FontAwesomeIcon type='submit' icon={faCheck} />
					</Button>
				</Col>
			</Row>
		</form>
	);
}

function FormularioMultiple(props) {
	const { Terminales, myVariable } = props;
	const [loading, setLoading] = useState(true);
	const [datosMultiples, setDatosMultiples] = useState([]);

	const agregarFormulario = () => {
		if (cambiar) {
			setDatosMultiples([...datosMultiples, {}]);
		} else {
			toast.error('Confirmar formulario actual para agregar mas ');
		}
	};

	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 1000);

	}, []);
	const confirmar = async () => {
		if (cambiar) {
			console.log(dato);
			try {
				const resultado = await axios.post(`${URL_EMPLOYEE}/desenganchadas/solicitudEnganchada`, dato)
				function reloadPage() {
					window.location.reload();
				}
				if (resultado.data['status']) {
					console.log(resultado.data['status']);
					toast.success(resultado.data['data'])
					setInterval(reloadPage, 2000);
				} else {
					toast.error(resultado.data['data'])

				};
			} catch (error) {
				toast.error('Algo salio mal..');
			}
			console.log(dato);
		} else {
			toast.error('Llenar o Verificar Formulario para Solicitar Desenchanche');
		}
	}

	return loading ? (
		<div className="cargando">
			<div className="loader" id="loader">
				Loading...
			</div>
		</div>
	) : (
		<>
			<Row className="mtop-40 mbottom-20 " >
				<Col className="cont-gris mbottom-20" xs={6} sm={4} md={4} lg={4} xl={4}>
					<div></div>
					<span>Formulario Vacio</span>

				</Col>
				<Col className="cont-azul  mbottom-20" xs={6} sm={4} md={4} lg={4} xl={4}>
					<div></div>
					<span>Placa Encontrada</span>
				</Col>
				<Col className="cont-verde  mbottom-20" xs={6} sm={4} md={4} lg={4} xl={4}>
					<div></div>
					<span>Placa no Encontrada</span>
				</Col>
			</Row>
			<Formulario Terminales={Terminales} />
			{datosMultiples.map((datos, index) => (
				<Formulario Terminales={Terminales} key={index} />
			))}
			<button className=" btn btn-primary mtop-20 boton" onClick={agregarFormulario}><FontAwesomeIcon icon={faPlus} /></button>
			<Row className="justify-content-end mbottom-20">
				<Button onClick={confirmar} variant="primary" className=" btn btn-primary mtop-20 boton"
				>
					Solicitar Desenganche
				</Button>
			</Row>


		</>

	);
}

export default FormularioMultiple;
